import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setLoading, showMessage} from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, arrayBufferToBase64, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';
import DateInput from '../../widgets/DateInput';
import TextArea from '../../widgets/TextArea';
import CheckBox from '../../widgets/CheckBox';
import ImagePicker from '../../widgets/ImagePicker';


export function EditWriterProfile() {
    // const [state, setState] = useState({writer:{firstName:''}, firstName:'', errors:{}});
    const [state, setState] = useState({writer:null, errors:{}, showDatePicker:false, showImagePicker:false, showAccountDeletionPopup:false, showAccountDeletionCode:false, accountDeletionCode:''});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getWriter();
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getWriter = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/user/`, config);
            showLoading(dispatch, false);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(reply.data.avatar && reply.data.avatar.length === 1) {
                    reply.data.avatar = reply.data.avatar[0];
                }

                setState({
                    ...state,
                    writer: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            dispatch(showMessage({message : errorMessage}));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
          
            const data = {firstName: state.writer.firstName.trim(), lastName: state.writer.lastName.trim(), dateOfBirth: state.writer.dateOfBirth, fewWordsAboutYourself: state.writer.fewWordsAboutYourself, howDoYouDefineYourself: state.writer.howDoYouDefineYourself, additionalNotes: state.writer.additionalNotes, avatar: state.writer.avatar};

            try {
                const reply = await axios.patch(API_URL + '/user', data, config);
                //console.log(reply);
                if(reply.hasOwnProperty('status') && reply.status === API_204) {
                    navigateTo(dispatch, navigate, "/writer-profile");
                }
            } catch (e) {
                if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };

    const handleChange = (e) => {
        change(e.target.id, e.target.value);
    };

    const change = (id, value) => {
        delete state.errors[id];
        setState({
            ...state, 
            writer:{...state.writer,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const toggleImagePicker = () => {
        setState({
            ...state,
            showImagePicker: !state.showImagePicker,
        });
    };


    const setAvatarImage = (image) => {
        setState({
            ...state,
            showImagePicker: false,
            writer:{...state.writer,
                ['avatar']: image,
            },
        });

    }

    const validateForm = () => {
        const errors = {};
        if (!state.writer.firstName?.trim() /*|| state.firstName.trim().length < 4*/) {
            errors['firstName'] = 'first_name_error';
        }

        if (!state.writer.lastName?.trim() /*|| state.firstName.trim().length < 4*/) {
            errors['lastName'] = 'last_name_error';
        }

        if (!state.writer.dateOfBirth) {
            errors['dateOfBirth'] = 'dote_of_birth_error';
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };

    const showAccountDeletionClick = (show) => {
        setState({
            ...state,
            showAccountDeletionPopup: show,
            showAccountDeletionCode: false,
            accountDeletionCode:''
        });
    }

    const handleCodeChange = (e) => {
        setState({
            ...state,
            accountDeletionCode: e.target.value
        });
    }

    const handleAccountDeletion = async () => {
        let errorMessage = DEFAULT_ERROR_TEXT;
        
        const data = {code:state.accountDeletionCode?state.accountDeletionCode.trim():null};
        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}, data: data};

        try {
            const reply = await axios.delete(API_URL + '/users/deleteaccount', config);
            console.log(reply);
            if(reply.hasOwnProperty('status') && reply.status === API_204) {
                if(!state.showAccountDeletionCode) {
                    setState({
                        ...state,
                        showAccountDeletionCode: true,
                        accountDeletionCode:''
                    });
                } else {
                    setState({
                        ...state,
                        showAccountDeletionPopup: false,
                        showAccountDeletionCode: false,
                        accountDeletionCode:''
                    });
                    dispatch(logout());
                    navigate('/start')
                }
            }
        } catch (e) {
            if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                errorMessage = e.response.data["errors"][0];
            }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate, true)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }
    };
    

    const accountDeletionPopup =() => {
        return (
            <div className='user-popup account-deletion-popup'>
                <img className='user-popup-image mt20' src={'/images/account_deletion.png'}  alt=''/>
                <div className='font-30 font-bold mr20 ml20 mt10'>{t('account_deletion')}</div>
                {!state.showAccountDeletionCode && <>
                    <div className='font-15 mr20 ml20 mt20'>{t('account_deletion_message')}</div>
                    <div className='popup-button small mt20 mb20' onClick={()=>handleAccountDeletion()}>{t('yes_i_am_sure')}</div>
                </>}
                {state.showAccountDeletionCode && <>
                    <div className='font-15 mr20 ml20 mt20'>{t('account_deletion_code_message')}</div>
                    <div className='mt10 width-90'>
                        <Input id="accountDeletionCode" placeholder={t("verification_code")} value={state.accountDeletionCode??''} onChange={(e) => handleCodeChange(e)}/>
                    </div>
                    <div className='popup-button small mt40 mb20' onClick={()=>handleAccountDeletion()}>{t('delete_my_account')}</div>
                </>}
                <img className='close-icon' src={'/images/close_x.png'} onClick={()=>showAccountDeletionClick(false)} alt=''/>
            </div>
        )
    }


    return (
        <Frame showMenu={true} showNav={true}>
            <div className='main main-writer-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.writer?<Background >
                            <div className='right-main-inner'>
                            {/* <form onSubmit={handleSubmit}> */}
                                <div className='mt60'>
                                    <Input className={state.errors.firstName?"error":""} id="firstName" placeholder={t("first_name")} value={state.writer.firstName??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.firstName && <div className='mt5 error font-12'><Trans i18nKey={state.errors.firstName} /></div>}

                                <div className='mt30'>
                                    <Input className={state.errors.lastName?"error":""} id="lastName" placeholder={t("last_name")} value={state.writer.lastName??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.lastName && <div className='mt5 error font-12'><Trans i18nKey={state.errors.lastName} /></div>}


                                <div className='center-div relative mt30'>
                                    <div className='center-div' onClick={()=>toggleImagePicker()}>
                                        <img src={state.writer.avatar?'/images/avatar.png':'/images/photo_upload.png'} className='avatar-border' alt=''/>
                                        <div className='avatar-div'>
                                            {state.writer.avatar &&<img src={arrayBufferToBase64(state.writer.avatar)} className='avatar' alt=''/>}
                                        </div>
                                    </div>
                                </div>
                                <div className='image-picker'>
                                    {state.showImagePicker && 
                                        <ImagePicker title={t('choose_profile_picture')} onSelected={(image)=>setAvatarImage(image)} onCancel={()=>toggleImagePicker()} avatar={true}/>
                                    }
                                </div>

                                <div className='mt25'>
                                    <DateInput id="dateOfBirth" placeholder={t("dote_of_birth")} value={state.writer.dateOfBirth} readOnly={true} onChange={(date) => change('dateOfBirth', date)} />
                                </div>
                                {state.errors.dateOfBirth && <div className='mt5 error font-12'><Trans i18nKey={state.errors.dateOfBirth} /></div>}


                                <div className='mt30'>
                                    <TextArea className={state.errors.fewWordsAboutYourself?"error":""} id="fewWordsAboutYourself" placeholder={t("few_words_about_yourself")} footer={t('up_to_300_words')} value={state.writer.fewWordsAboutYourself??''} onChange={(e) => handleChange(e)}/>
                                </div>

                                <div className='mt30 font-15'>
                                    <CheckBox id='writing_to_the_drawer' text={t('writing_to_the_drawer')} value={state.writer.howDoYouDefineYourself} onChange={(id) => change('howDoYouDefineYourself', id)} />
                                    <CheckBox id='writing_as_a_hobby' text={t('writing_as_a_hobby')} value={state.writer.howDoYouDefineYourself} onChange={(id) => change('howDoYouDefineYourself', id)} />
                                    <CheckBox id='beginner_writer' text={t('beginner_writer')} value={state.writer.howDoYouDefineYourself} onChange={(id) => change('howDoYouDefineYourself', id)} />
                                    <CheckBox id='experienced_writer' text={t('experienced_writer')} value={state.writer.howDoYouDefineYourself} onChange={(id) => change('howDoYouDefineYourself', id)} />
                                </div>
                                

                                <div className='button-form mt20 mb40' onClick={(e) => handleSubmit(e)}>  <div>{t("edit")}</div> </div>
                                <div className='button-form background-932790 color-white mt20 mb40' onClick={() => showAccountDeletionClick(true)}>  <div>{t("account_deletion")}</div> </div>
                            </div>
                            </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
            {state.showAccountDeletionPopup && accountDeletionPopup()}
        </Frame>
    );
}